import { Header, Spinner } from 'view/components';
import { CandidateContactCard, CandidateProfileBlock } from 'view/pages/candidates/components';
/* import { useNavigate } from 'react-router'; */
import { useEffect } from 'react';
import { useGetJobSeekerProfileById } from 'view/pages/candidates/hooks/useGetJobSeekerProfileById';
import { useMediaQuery } from '@mui/material';
import { theme } from 'view/themes/theme';
import { useContextSelector as useCS } from 'use-context-selector';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { useLocation } from 'react-router-dom';
import { useUpdateApplicationStatus } from 'view/pages/candidates/hooks/useUpdateApplicationStatus';
import * as S from './styled';

const CandidateProfile = () => {
  /* const navigate = useNavigate(); */
  const location = useLocation();
  const matches = useMediaQuery(theme.breakpoints.down('laptop'));
  const { role } = useCS(GlobalConfigContext, globalConfigSelectors.userData);

  const params = new URLSearchParams(window.location.search);
  const id = params.get('id');
  const jobPostId: any = params.get('jobPostId');
  const redirectedFrom: any = params.get('redirectedFrom');
  const applicationId: any = params.get('applicationId');

  const { isLoading, getJobSeekerProfileById, data } = useGetJobSeekerProfileById();
  const { isLoading: isUpdateApplicationStatusLoading, updateApplicationStatus } =
    useUpdateApplicationStatus();

  useEffect(() => {
    if (!id && location.pathname === '/candidates/candidate-profile') {
      /* navigate('/candidates/candidates-list', { replace: true }); */ // TO DO NEED TO FIX
      return;
    }
    if (redirectedFrom && redirectedFrom === 'email' && applicationId) {
      updateApplicationStatus(
        {
          statusForCandidate: 'Applied',
          statusForRecruiter: 'Pending',
        },
        applicationId,
        () => {
          getJobSeekerProfileById(id, jobPostId);
        }
      );
    } else {
      getJobSeekerProfileById(id, jobPostId);
    }
  }, [id, jobPostId, redirectedFrom]);

  return (
    <S.Wrapper>
      <Header />
      {/* <S.BreadcrumbsContainer /> */}
      {isLoading || isUpdateApplicationStatusLoading || !data ? (
        <S.MainContentWrapper
          style={{
            background: '#fff',
            height: 'calc(100vh - 120px)',
            borderRadius: '24px',
            padding: '24px',
          }}
        >
          <Spinner variant="outlined" style={{ position: 'absolute', top: '50%', left: '50%' }} />
        </S.MainContentWrapper>
      ) : (
        <S.MainContentWrapper style={{ marginBottom: matches ? '200px' : '0px' }}>
          <CandidateProfileBlock
            data={data}
            jobPostId={jobPostId}
            roleName={role?.name}
            getJobSeekerProfileById={getJobSeekerProfileById}
          />
          {role?.name === RolesEnum.JOB_SEEKER ? null : (
            <CandidateContactCard
              data={data}
              jobPostId={jobPostId}
              getJobSeekerProfileById={() => {
                return getJobSeekerProfileById(id, jobPostId);
              }}
            />
          )}
        </S.MainContentWrapper>
      )}
    </S.Wrapper>
  );
};

export default CandidateProfile;
